<template>
  <div>
    <div v-if="servicesList.header" class="row">
      <h2 v-bind:class="{ bigHeader: servicesList.bigHeader }">
        {{ servicesList.header }}
      </h2>
    </div>
    <ul class="tiles">
      <li
        v-for="(item, index) in servicesList.list"
        v-bind:key="index"
        v-bind:class="{ boldHeader: boldHeader }"
        class="serviceList"
      >
        <div v-if="item.list">
          <h3>
            <span v-if="showNumber" class="number"></span>
            {{ item.text }}
          </h3>
          <ul>
            <li v-for="(item, index) in item.list" v-bind:key="index">
              {{ item }}
            </li>
          </ul>
        </div>
        <div v-else-if="!item.list && !item.paragraph">
          <p v-if="showNumber"><span class="number"></span></p>
          <p>
            {{ item.text }}
          </p>
        </div>
        <div v-else>
          <h3>
            <span v-if="showNumber" class="number"></span>
            {{ item.text }}
          </h3>
          <p :data-full-text="item.paragraph">
            {{ item.exerpt }}
          </p>
          <span
            v-if="switchButton"
            class="switchButton showMore"
            v-on:click="showMore()"
          >
            {{ translations.showMore }}
          </span>
          <span
            v-if="switchButton"
            class="switchButton showLess hidden"
            v-on:click="showLess()"
          >
            {{ translations.showLess }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ServicesList",
  props: {
    servicesList: Object,
    translations: Object,
    showNumber: {
      type: Boolean,
      default: false,
    },
    withZeroInFront: {
      type: Boolean,
      default: false,
    },
    withDot: {
      type: Boolean,
      default: false,
    },
    boldHeader: {
      type: Boolean,
      default: false,
    },
    switchButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showMore() {
      const parent = event.target.parentElement;
      const paragraphs = parent.querySelectorAll("p");

      event.target.classList.add("hidden");
      parent.querySelector(".showLess").classList.remove("hidden");

      paragraphs.forEach((p) => {
        p.setAttribute("data-exerpt", p.textContent);
        p.textContent = p.getAttribute("data-full-text");
      });
    },
    showLess() {
      const parent = event.target.parentElement;
      const paragraphs = parent.querySelectorAll("p");

      event.target.classList.add("hidden");
      parent.querySelector(".showMore").classList.remove("hidden");

      paragraphs.forEach((p) => {
        p.setAttribute("data-full-text", p.textContent);
        p.textContent = p.getAttribute("data-exerpt");
      });
    },
  },
  mounted: function () {
    if (this.showNumber) {
      let servicesList = this.$vnode.elm.querySelectorAll(".serviceList");
      if (servicesList) {
        servicesList = this.nodeListToArray(servicesList);

        servicesList.forEach((element, index) => {
          let number = element.querySelector(".number");
          this.withZeroInFront && (number.textContent += "0");
          number.textContent += index + 1;
          this.withDot && (number.textContent += ".");
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/colors";
@import "../scss/utils";

.hidden {
  display: none !important;
}

.switchButton {
  display: block;
  margin-top: 5px;
  cursor: pointer;
  text-decoration: underline;
}

.number {
  line-height: inherit;
  font-size: inherit;
  color: inherit;
}

.boldHeader {
  h3 {
    font-weight: bold;
  }
}

h2 {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 14px;

  &.bigHeader {
    font-size: 30px;
    font-weight: 100;
    text-transform: none;
  }
}

.tiles {
  @extend .d-f;
  flex-wrap: wrap;

  h2 {
    margin-bottom: 23px;

    @include mobile() {
      text-align: center;
    }
  }

  .serviceList {
    width: 33.33%;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0;

    h3 {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 8px;
    }

    li {
      position: relative;
      font-size: 13px;
      text-align: left !important;

      &:before {
        display: inline;
        content: "- ";
      }
    }

    @include mobile() {
      width: 50%;
    }

    @include mobile-s() {
      width: 100%;
    }

    @include desktop-s() {
      padding: 20px 80px 20px 0px;
      box-sizing: border-box;
    }
  }
}
</style>
